export default __webpack_public_path__ + "static/media/Reimbursement_1.e100f369.png";